import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Azienda } from '../../models/azienda';
import { Orfricliente } from '../../models/orfricliente';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { configurazione } from '../../../configurazioni/configurazione';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-aziende',
  templateUrl: './aziende.component.html',
  styleUrls: ['./aziende.component.css']
})
export class AziendeComponent implements OnInit {
  IPAddress:string;
  Port:string;
  Protocol: string;
  aziende: Azienda[]=[];
  aziendeincache: Azienda[] = [];
  aziendeselezionate: Azienda[]=[];
  azienda: Azienda=new Azienda();
  orfriclienti: Orfricliente[]=[];
  displayedColumns: string[] = [
  "sel",
  "Nome",
  "Partitaiva",
  "Missione",
  "Codicefiscale",
  "Email",
  "Pec",
  "Telefono",
  "Cellulare",
  "Svi",
  "Ragionesociale",
  "Attivita",
  "Numerodipendenti",
  "Rea",
  "Datarea",
  "Cameracommercio",
  "Isactive",
  "edit",
  "customdata"];

  displayedColumns2: string[] = [
  "Attributo",
  "Valore"];

  filtroCliente: string;
  spinnervalue = 100;
  busy = false;

  showcustomadata: boolean=false;

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();

  dataSource = new MatTableDataSource<Azienda>(this.aziende);
  dataSource2 = new MatTableDataSource<Orfricliente>(this.orfriclienti);

  @ViewChild('paginator') paginator: MatPaginator;
  selection = new SelectionModel<Azienda>(true, []);

  constructor(private httpClient: HttpClient, private router: Router, private commonService: CommonService) {}

  ngOnInit() {
    this.sortedDirection.set("Nome",true);
    this.sortedDirection.set("Partitaiva",true);
    this.sortedDirection.set("Missione",true);
    this.sortedDirection.set("Codicefiscale",true);
    this.sortedDirection.set("Email",true);
    this.sortedDirection.set("Pec",true);
    this.sortedDirection.set("Telefono",true);
    this.sortedDirection.set("Cellulare",true);
    this.sortedDirection.set("Svi",true);
    this.sortedDirection.set("Ragionesociale",true);
    this.sortedDirection.set("Attivita",true);
    this.sortedDirection.set("Numerodipendenti",true);
    this.sortedDirection.set("Rea",true);
    this.sortedDirection.set("Datarea",true);
    this.sortedDirection.set("Cameracommercio",true);
    this.sortedDirection.set("Isactive",true);


    if (this.commonService.currentUser===undefined || this.commonService.currentUser===null){
      const username=sessionStorage.getItem('username');
      this.commonService.getUser(username).subscribe(data => {
        this.commonService.currentUser=data;
        this.commonService.currentAziendaCodice=this.commonService.currentUser.Codiceazienda;
        this.aggiornaLista();
      });
    }else{
      this.aggiornaLista();
    }
  }

  isBusy(){
    return this.busy;
  }


  cancel(){
    this.selection.clear();
    this.aggiornaLista();
  }

  deleteAzienda(azienda: Azienda): void {
    this.commonService.deleteAzienda(azienda).subscribe(data => {
      this.aziende = this.aziende.filter(a => a !== azienda);
    });
  }

  toggleEnable(azienda: Azienda){
    //selection.toggle(row);
    const aziendaData = new FormData();
//    aziendaData.append('codice', azienda.Codice); // METTERE UN CAMPO CHE IDENTIFICA L'AZIENDA
    this.httpClient.put(this.Protocol+"://"+this.IPAddress+":"+this.Port+"/api/aziende/toggle", aziendaData, { observe: 'response' })
    .subscribe((response) => {
        this.aggiornaLista();
    });
  }

  aggiornaLista(){
//    let nomeruolo:String="";
//    if (this.selectedValueRuolo!=undefined){
//     nomeruolo=this.selectedValueRuolo;
//    }
    this.busy = true;
    this.commonService
      .getAllAziende()
      .subscribe(response => {


        

        let tempaziende:Azienda[]=response;
  //      let templistausers:User[]=[];
  //      tempusers.forEach(element => {
  //        const user:User=element;
  //        user.Nomeruolo=this.getNomeByCodiceruolo(element.Codiceruolo);
          //console.log("Nome ruolo="+user.Nomeruolo);
  //        if (nomeruolo==="" || nomeruolo===user.Nomeruolo){
  //          templistausers.push(user);
  //        }
  //      });
        this.busy = false;
        this.refreshLista(tempaziende);
      });
   }
   refreshLista(listaaziende:Azienda[]){
    
     this.aziende=listaaziende;
     this.aziendeincache = listaaziende;
     this.dataSource = new MatTableDataSource<Azienda>(this.aziende);
     this.dataSource.paginator = this.paginator;

   }
/*
  handleSuccessfulResponse(response) {

    let tempusers:Array<User>=response;
    tempusers.forEach(element => {
      const user:User=element;
      user.Nomeruolo=this.getNomeByCodiceruolo(element.Codiceruolo);
      this.users.push(user);
    });


  }
*/
  newAzienda(){
    this.router.navigate(['addazienda']);
  }
  editAzienda(azienda: Azienda): void {
      this.commonService.selectedAzienda=azienda;
      this.router.navigate(['addazienda']);
  }

  manageClick(attributo: string){
    //alert(ev.target)
/*
    switch (_case) {
         case 'number':
           this.elements2.sort((a, b) => {
             return a.position - b.position;
           });
           break;
         case 'text':
  */
    let tempList:Azienda[];
    tempList=this.aziende;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);

     this.dataSource = new MatTableDataSource<Azienda>(this.aziende);

   }
   isDetailsHidden(){
     if (this.selection.selected.length===0){
       return 'none';
     }else{
       return'';
     }
   }

   manageCheckboxclick(event, a:Azienda){
     this.aziendeselezionate=[];
     this.azienda=a;
     let found:boolean=false;
     this.selection.selected.forEach(row => {
       if (row.Codice!=a.Codice){
         this.selection.deselect(row);
       }else{
         found=true;
         this.aziendeselezionate.push(a);
       }
     });
     if (!found){
       this.azienda=new Azienda();
       this.aziendeselezionate=[];
     }
     event.stopPropagation();
     if (this.aziendeselezionate.length>0){
       this.customdataAzienda(this.aziendeselezionate[0]);
      }
   }

  customdataAzienda(azienda: Azienda){
    this.azienda=azienda;
    if (this.commonService.currentIstanza!=undefined){
      if (this.commonService.currentIstanza.Codice === 1){

      }else if (this.commonService.currentIstanza.Codice === 2){

      }else if (this.commonService.currentIstanza.Codice === 3){

      }else if (this.commonService.currentIstanza.Codice === 4){

      }else if (this.commonService.currentIstanza.Codice === 5){

      }else if (this.commonService.currentIstanza.Codice === 6){

         this.commonService.getAllOrfriclientiByAzienda(azienda.Codice).subscribe(res => {
           this.orfriclienti=res;
           this.dataSource2 = new MatTableDataSource<Orfricliente>(this.orfriclienti);
           this.showcustomadata=true;

         });
      }else if (this.commonService.currentIstanza.Codice === 7){

      }
    }
   }

    onFiltroClienteKeyup(event:any){
      this.aziende=this.aziendeincache;
      if (event.target.value!=undefined){
        this.aziende = this.aziende.filter(a=> a.Nome.toLowerCase().indexOf(event.target.value.toLowerCase())>-1);
        this.dataSource = new MatTableDataSource<Azienda>(this.aziende);
        this.dataSource.paginator = this.paginator;
      }
    }

   getConfigurazione(){
     if (this.commonService.currentIstanza!=undefined){
       if (this.commonService.currentIstanza.Codice === 1){
         return configurazione.azienda.fb;
       }else if (this.commonService.currentIstanza.Codice === 2){
         return configurazione.azienda.fb;
       }else if (this.commonService.currentIstanza.Codice === 3){
         return configurazione.azienda.fb;
       }else if (this.commonService.currentIstanza.Codice === 4){
         return configurazione.azienda.fb;
       }else if (this.commonService.currentIstanza.Codice === 5){
         return configurazione.azienda.fb;
       }else if (this.commonService.currentIstanza.Codice === 6){
         return configurazione.azienda.orfri;
       }else if (this.commonService.currentIstanza.Codice === 7){
         return configurazione.azienda.fb;
       }
     }
     return configurazione.azienda.fb;
   }


}
